module.exports = __webpack_public_path__ + "img/73-r.ae39bea5.png";